import { render, staticRenderFns } from "./ClienteWindow.vue?vue&type=template&id=575431a8"
import script from "./ClienteWindow.vue?vue&type=script&lang=js"
export * from "./ClienteWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports